/**
 * Format a seen_by array as "Seen by John Agent · 2 min ago" or
 * "Seen by 2 people · just now" (most recent timestamp).
 */
const ROLE_LABEL = { solicitor: "Solicitor", client: "Client", referrer: "Referrer" };

function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const sec = Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));
  if (sec < 30) return "just now";
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

export function ReadReceipt({ seenBy, currentActorName, currentActorRole }) {
  if (!seenBy || seenBy.length === 0) return null;
  // Filter out self from receipts (don't show "you saw it")
  const others = seenBy.filter(
    (s) => !(s.actor_name === currentActorName && s.actor_role === currentActorRole),
  );
  if (others.length === 0) return null;
  // Use most recent timestamp
  const sorted = [...others].sort((a, b) => (b.seen_at || "").localeCompare(a.seen_at || ""));
  const latest = sorted[0];
  const label = others.length === 1
    ? `Seen by ${latest.actor_name}`
    : `Seen by ${others.length} ${ROLE_LABEL[latest.actor_role]?.toLowerCase() || "people"}${others.length === 1 ? "" : "s"}`;
  return (
    <span className="text-[10px] text-slate-400 italic" data-testid="read-receipt">
      ✓ {label} · {timeAgo(latest.seen_at)}
    </span>
  );
}
